/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v27.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var KeyCode = /** @class */ (function () {
    function KeyCode() {
    }
    KeyCode.BACKSPACE = 'Backspace';
    KeyCode.TAB = 'Tab';
    KeyCode.ENTER = 'Enter';
    KeyCode.ESCAPE = 'Escape';
    KeyCode.SPACE = ' ';
    KeyCode.LEFT = 'ArrowLeft';
    KeyCode.UP = 'ArrowUp';
    KeyCode.RIGHT = 'ArrowRight';
    KeyCode.DOWN = 'ArrowDown';
    KeyCode.DELETE = 'Delete';
    KeyCode.A = 'A';
    KeyCode.C = 'C';
    KeyCode.V = 'V';
    KeyCode.D = 'D';
    KeyCode.Z = 'Z';
    KeyCode.Y = 'Y';
    KeyCode.F2 = 'F2';
    KeyCode.PAGE_UP = 'PageUp';
    KeyCode.PAGE_DOWN = 'PageDown';
    KeyCode.PAGE_HOME = 'Home';
    KeyCode.PAGE_END = 'End';
    return KeyCode;
}());
export { KeyCode };
